(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-component"] && !Shopify.designMode) return;
  try {
    class BundleComponent extends HTMLElement {
    constructor() {
      super();
      this.itemsCountElem = this.querySelector('[data-bundle-items-count]');
      this.totalPriceElem = this.querySelector('[data-bundle-total-price]');
      this.submitBtn = this.querySelector('[data-bundle-submit]');
      this.errorElem = this.querySelector('[data-bundle-error]');
    }

    connectedCallback() {
      this.onCheckboxChangeBound = this.onCheckboxChange.bind(this);
      this.onQuantityChangeBound = this.onQuantityChange.bind(this);
      this.onSubmitBound = this.onSubmit.bind(this);

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-bundle-checkbox]')) {
          this.onCheckboxChange(e);
        } else if (e.target.matches('input[name="quantity"]')) {
          this.onQuantityChange(e);
        } else if (e.target.matches('input[type="radio"]')) {
          setTimeout(() => this.updateTotals(), 50);
        }
      });

      this.addEventListener('keydown', (e) => {
        if (e.target.matches('[data-bundle-checkbox]') && (e.key === 'Enter' || e.keyCode === 13)) {
          e.preventDefault();
          e.target.click();
        }
      });

      this.addEventListener('input', (e) => {
        if (e.target.matches('input[name="quantity"]')) {
          this.onQuantityChange(e);
        }
      });

      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', this.onSubmitBound);
      }

      this.updateTotals();
    }

    onCheckboxChange(event) {
      const checkbox = event.target;
      const row = checkbox.closest('[data-bundle-row]');
      if (!row) return;

      if (checkbox.checked) {
        row.classList.remove('is-unchecked');
      } else {
        row.classList.add('is-unchecked');
      }
      this.clearRowError(row);
      this.clearError();
      this.updateTotals();
    }

    onQuantityChange(event) {
      const input = event.target;
      const row = input ? input.closest('[data-bundle-row]') : null;
      if (row) this.clearRowError(row);
      this.clearError();
      this.updateTotals();
    }

    clearError() {
      if (this.errorElem) {
        this.errorElem.classList.add('hidden');
        const errSpan = this.errorElem.querySelector('[data-error]');
        if (errSpan) errSpan.innerText = '';
      }
    }

    clearRowError(row) {
      if (!row) return;
      const errElem = row.querySelector('[data-product-bundle-error], .product-bundle-row_error');
      if (errElem) {
        errElem.classList.add('hidden');
        const errSpan = errElem.querySelector('[data-error]');
        if (errSpan) errSpan.innerText = '';
      }
    }

    clearAllRowErrors() {
      const rows = Array.from(this.querySelectorAll('[data-bundle-row]'));
      rows.forEach((row) => this.clearRowError(row));
    }

    showError(msg) {
      if (this.errorElem) {
        this.errorElem.classList.remove('hidden');
        const errSpan = this.errorElem.querySelector('[data-error]');
        if (errSpan) errSpan.innerText = msg;
      }
    }

    getErrorMessage(response) {
      if (!response) return 'Could not add this product to cart. Please check quantity or try again.';
      if (typeof response.description === 'string' && response.description.trim() && response.description.trim() !== 'Cart Error') {
        return response.description.trim();
      }
      if (response.errors) {
        if (typeof response.errors === 'string') return response.errors;
        if (Array.isArray(response.errors)) return response.errors.join(', ');
        if (typeof response.errors === 'object') {
          const msgs = [];
          for (const key in response.errors) {
            const val = response.errors[key];
            if (Array.isArray(val)) {
              msgs.push(val.join(', '));
            } else if (typeof val === 'string') {
              msgs.push(val);
            }
          }
          if (msgs.length > 0) return msgs.join('. ');
        }
      }
      if (response.message && response.message !== 'Cart Error') {
        return response.message;
      }
      return 'The requested quantity or item is not available. Please check quantity or try again.';
    }

    showRowError(row, msg) {
      if (!row) return;
      const errElem = row.querySelector('[data-product-bundle-error], .product-bundle-row_error');
      if (errElem) {
        errElem.classList.remove('hidden');
        const errSpan = errElem.querySelector('[data-error]');
        if (errSpan) errSpan.innerText = msg;
      }
    }

    scrollToRow(row) {
      if (!row) return;
      const headerArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
      const headerOffset = headerArea ? headerArea.getBoundingClientRect().height : 0;
      const targetY = row.getBoundingClientRect().top + window.pageYOffset - headerOffset - 24;
      if (window.gsap && window.ScrollToPlugin) {
        window.gsap.to(window, {
          duration: 0.6,
          scrollTo: { y: row, offsetY: headerOffset + 24 },
          ease: 'power2.out'
        });
      } else {
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }
      const focusTarget = row.querySelector('input[type="checkbox"], a, button, input') || row;
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (e) {
        focusTarget.focus();
      }
    }

    updateTotals() {
      const rows = Array.from(this.querySelectorAll('[data-bundle-row]'));
      let totalQty = 0;
      let totalPrice = 0;

      rows.forEach((row) => {
        const checkbox = row.querySelector('[data-bundle-checkbox]');
        const isChecked = checkbox ? checkbox.checked : true;
        if (!isChecked) return;

        const qtyInput = row.querySelector('input[name="quantity"]');
        const qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
        totalQty += qty;

        const customQtyInput = row.querySelector('quantity-input-custom, quantity-input');
        let variantPrice = customQtyInput && customQtyInput.dataset.variantPrice
          ? parseInt(customQtyInput.dataset.variantPrice)
          : parseInt(row.dataset.variantPrice || 0);

        if (isNaN(variantPrice)) variantPrice = 0;
        totalPrice += qty * variantPrice;
      });

      if (this.itemsCountElem) {
        this.itemsCountElem.textContent = totalQty;
      }

      if (this.totalPriceElem) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          this.totalPriceElem.innerHTML = Shopify.formatMoney(totalPrice, window.money_format);
        } else {
          this.totalPriceElem.textContent = '$' + (totalPrice / 100).toFixed(2);
        }
      }

      if (this.submitBtn) {
        if (totalQty === 0) {
          this.submitBtn.setAttribute('disabled', 'disabled');
        } else {
          this.submitBtn.removeAttribute('disabled');
        }
      }
    }

    getSelectedItems() {
      const items = [];
      const rows = Array.from(this.querySelectorAll('[data-bundle-row]'));

      rows.forEach((row) => {
        const checkbox = row.querySelector('[data-bundle-checkbox]');
        const isChecked = checkbox ? checkbox.checked : true;
        if (!isChecked) return;

        const customQtyInput = row.querySelector('quantity-input-custom, quantity-input');
        const qtyInput = row.querySelector('input[name="quantity"]');
        const qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

        let variantId = row.dataset.variantId;
        const hiddenVariantInput = row.querySelector('input[name="id"]');
        if (hiddenVariantInput && hiddenVariantInput.value) {
          variantId = hiddenVariantInput.value;
        }

        if (variantId && !isNaN(parseInt(variantId))) {
          items.push({
            id: parseInt(variantId),
            quantity: qty
          });
        }
      });

      return items;
    }

    resetQuantities() {
      const rows = Array.from(this.querySelectorAll('[data-bundle-row]'));
      rows.forEach((row) => {
        const customQty = row.querySelector('quantity-input-custom, quantity-input');
        if (customQty && typeof customQty.resetQuantity === 'function') {
          customQty.resetQuantity();
        } else {
          const input = row.querySelector('input[name="quantity"]');
          if (input) {
            const minVal = parseInt(input.min) || parseInt(input.dataset.min) || 1;
            input.value = minVal;
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      });
      this.updateTotals();
    }

    onSubmit(event) {
      event.preventDefault();
      this.clearError();
      this.clearAllRowErrors();

      const rows = Array.from(this.querySelectorAll('[data-bundle-row]'));
      const checkedRows = rows.filter((row) => {
        const checkbox = row.querySelector('[data-bundle-checkbox]');
        return checkbox ? checkbox.checked : true;
      });

      if (checkedRows.length === 0) {
        this.showError('Please select at least one item to add to the bundle.');
        return;
      }

      const sellingPlanRows = checkedRows.filter((row) => row.dataset.requiresSellingPlan === 'true');
      if (sellingPlanRows.length > 0) {
        const errorMsg = 'Variant can only be purchased with a selling plan.';
        sellingPlanRows.forEach((row) => {
          this.showRowError(row, errorMsg);
        });
        this.scrollToRow(sellingPlanRows[0]);
        return;
      }

      const invalidQtyRows = [];
      for (const row of checkedRows) {
        const qtyInput = row.querySelector('input[name="quantity"]');
        if (qtyInput) {
          const qty = parseInt(qtyInput.value) || 0;
          const min = parseInt(qtyInput.min) || parseInt(qtyInput.dataset.min) || 1;
          const max = parseInt(qtyInput.max) || parseInt(qtyInput.dataset.max);
          if (qty < min) {
            invalidQtyRows.push({ row, msg: `Minimum quantity is ${min}.` });
          } else if (!isNaN(max) && max > 0 && qty > max) {
            invalidQtyRows.push({ row, msg: `Maximum quantity is ${max}.` });
          }
        }
      }

      if (invalidQtyRows.length > 0) {
        this.resetQuantities();
        invalidQtyRows.forEach(({ row, msg }) => {
          this.showRowError(row, msg);
        });
        this.scrollToRow(invalidQtyRows[0].row);
        return;
      }

      const items = this.getSelectedItems();
      if (items.length === 0) {
        this.showError('Please select at least one item to add to the bundle.');
        return;
      }

      const button = this.submitBtn;
      if (button) button.classList.add('btn-loading');

      const secArrStr = button ? button.dataset.sections : '[]';
      let secArr = [];
      try {
        secArr = JSON.parse(secArrStr);
      } catch (e) {
        secArr = [];
      }

      const payload = {
        items: items,
        sections: secArr.map(s => s.id),
        sections_url: window.location.pathname
      };

      fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript, application/json'
        },
        body: JSON.stringify(payload)
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status && response.status >= 400) {
            const errorMsg = this.getErrorMessage(response);
            const isSellingPlanErr = errorMsg.toLowerCase().includes('selling plan') || errorMsg.toLowerCase().includes('selling_plan');
            let targetRow = null;
            if (isSellingPlanErr) {
              targetRow = checkedRows.find((r) => r.dataset.requiresSellingPlan === 'true');
            }
            if (!targetRow && errorMsg) {
              const msgLower = errorMsg.toLowerCase();
              targetRow = checkedRows.find((r) => {
                const heading = r.querySelector('.product-bundle-row_heading, [class*="_heading"]');
                const titleText = heading ? heading.textContent.trim().toLowerCase() : '';
                return titleText && msgLower.includes(titleText);
              });
            }
            if (!targetRow && checkedRows.length === 1) {
              targetRow = checkedRows[0];
            }
            if (!targetRow) {
              targetRow = checkedRows.find((r) => {
                const qtyInput = r.querySelector('input[name="quantity"]');
                return qtyInput && (parseInt(qtyInput.value) || 1) > 1;
              }) || checkedRows[0];
            }

            if (secArr.length > 0 && response.sections) {
              secArr.forEach((section) => {
                const sectionHtml = response.sections[section.id];
                if (!sectionHtml) return;
                const parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
                const html = parsedDoc.getElementById(section.id) || parsedDoc;
                section.selectors.forEach((selector) => {
                  const targetElement = document.querySelector(selector);
                  const sourceElement = html.querySelector(selector);
                  if (targetElement && sourceElement) {
                    targetElement.outerHTML = sourceElement.outerHTML;
                  }
                });
              });
            }

            this.resetQuantities();

            if (targetRow) {
              this.showRowError(targetRow, errorMsg);
              this.scrollToRow(targetRow);
            } else {
              this.showError(errorMsg);
            }
            return;
          }

          this.resetQuantities();
          this.clearError();
          this.clearAllRowErrors();

          if (secArr.length > 0 && response.sections) {
            secArr.forEach((section) => {
              const sectionHtml = response.sections[section.id];
              if (!sectionHtml) return;
              const parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
              const html = parsedDoc.getElementById(section.id) || parsedDoc;
              section.selectors.forEach((selector) => {
                const targetElement = document.querySelector(selector);
                const sourceElement = html.querySelector(selector);
                if (targetElement && sourceElement) {
                  targetElement.outerHTML = sourceElement.outerHTML;
                }
              });
            });
          }

          if (button.dataset.redirect) {
            window.location.href = button.dataset.redirect;
            return;
          }

          if (button.dataset.modal === 'true') {
            const drawerToggler = document.querySelector(button.dataset.modalRef);
            if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
        })
        .catch((err) => {
          console.error(err);
          this.showError('An error occurred while adding the bundle.');
        })
        .finally(() => {
          if (button) button.classList.remove('btn-loading');
        });
    }
  }

  if (!customElements.get('bundle-component')) {
    customElements.define('bundle-component', BundleComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["burger-mega-dropdown"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MegaBurgerMenuDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('burger-mega-menu-dropdown[data-level="1"]') || this.closest('burger-menu-dropdown[data-level="1"]') || this.closest('menu-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      // GSAP slide + fade reveal, reading window.themeMotion tokens — mobile
      // drawer panels get a directional slide instead of the flat WAAPI
      // opacity fade every dropdown used before.
      const doAnimate = () => {
        if (!window.gsap) return null;
        var _M = window.themeMotion || {};
        window.gsap.killTweensOf(this.content);
        window.gsap.set(this.content, { opacity: 0, x: 24 });
        return window.gsap.to(this.content, {
          opacity: 1, x: 0,
          duration: (_M.dur && _M.dur.base) || 0.4,
          ease: (_M.ease && _M.ease.ui) || 'power3.out'
        });
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        this.content.style.top = '';
        const otherOpen = document.querySelectorAll('.dropdown--open');
        if (otherOpen.length === 0) {
          document.body.classList.remove('overflow-hidden');
          const headerFixedArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
          if (headerFixedArea) headerFixedArea.classList.remove('is-header-open');
        }
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content && this.onParentScroll) outerSelf.content.removeEventListener('scroll', this.onParentScroll);
          if (outerSelf.content) outerSelf.content.style.overflowY = 'auto';
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        this.button.focus();
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        this.content.style.position = '';
        this.content.style.marginTop = '';
        this.content.style.maxHeight = '';
        this.content.style.overflowY = '';
        this.content.style.top = '';
        this.content.style.left = '';
        document.body.classList.add('overflow-hidden');
        const headerFixedArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
        if (headerFixedArea) headerFixedArea.classList.add('is-header-open');
        this.content.style.maxHeight = '100vh';
        this.content.style.overflowY = 'auto';
        if (isLevel2 && outerSelf && outerSelf.content) {
          this.content.style.top = `${outerSelf.content.scrollTop}px`;
          outerSelf.content.style.overflowY = 'hidden';
        }
        this.content.scrollTop = 0;
        const animation = doAnimate();
        if (animation) {
          const originalOverflow = this.content.style.overflowY;
          this.content.style.overflowY = 'hidden';
          animation.then(() => {
            this.content.style.overflowY = originalOverflow || '';
          });
        }
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('burger-mega-menu-dropdown')) customElements.define('burger-mega-menu-dropdown', MegaBurgerMenuDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["burger-menu-dropdown"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MenuBurgerDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('burger-menu-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      // GSAP slide + fade reveal, reading window.themeMotion tokens — mobile
      // drawer panels get a directional slide instead of the flat WAAPI
      // opacity fade every dropdown used before.
      const doAnimate = () => {
        if (!window.gsap) return null;
        var _M = window.themeMotion || {};
        window.gsap.killTweensOf(this.content);
        window.gsap.set(this.content, { opacity: 0, x: 24 });
        return window.gsap.to(this.content, {
          opacity: 1, x: 0,
          duration: (_M.dur && _M.dur.base) || 0.4,
          ease: (_M.ease && _M.ease.ui) || 'power3.out'
        });
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        this.content.style.top = '';
        const otherOpen = document.querySelectorAll('.dropdown--open');
        if (otherOpen.length === 0) {
          document.body.classList.remove('overflow-hidden');
          const headerFixedArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
          if (headerFixedArea) headerFixedArea.classList.remove('is-header-open');
        }
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content) outerSelf.content.style.overflowY = 'auto';
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        this.button.focus();
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        this.content.style.position = '';
        this.content.style.marginTop = '';
        this.content.style.maxHeight = '';
        this.content.style.overflowY = '';
        this.content.style.top = '';
        this.content.style.left = '';
        document.body.classList.add('overflow-hidden');
        const headerFixedArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
        if (headerFixedArea) headerFixedArea.classList.add('is-header-open');
        this.content.style.maxHeight = '100vh';
        this.content.style.overflowY = 'auto';
        if (isLevel2 && outerSelf && outerSelf.content) {
          this.content.style.top = `${outerSelf.content.scrollTop}px`;
          outerSelf.content.style.overflowY = 'hidden';
        }
        this.content.scrollTop = 0;
        const animation = doAnimate();
        if (animation) {
          const originalOverflow = this.content.style.overflowY;
          this.content.style.overflowY = 'hidden';
          animation.then(() => {
            this.content.style.overflowY = originalOverflow || '';
          });
        }
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('burger-menu-dropdown')) customElements.define('burger-menu-dropdown', MenuBurgerDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };

  class CartTruncateText extends HTMLElement {
    constructor() {
      super();
      this.truncateLength = parseInt(this.getAttribute('truncate-length')) || 5;
      this.originalText = '';
      this.isExpanded = false;
      this.toggleButton = null;
    }

    connectedCallback() {
      const toggleButton = this.querySelector('.toggle-text');
      if (!toggleButton) return;

      this.toggleButton = toggleButton;
      toggleButton.remove();

      this.originalText = this.innerHTML.trim();
      this.appendChild(toggleButton);

      toggleButton.addEventListener('click', this.toggleTruncate.bind(this));
      this.truncateContent();
    }

    truncateContent() {
      const words = this.originalText.trim().split(/\s+/);
      if (words.length <= this.truncateLength) {
        this.toggleButton.style.display = 'none';
        return;
      }

      this.innerHTML = '';

      // Use Shopify translation text stored in data attributes
      const readMoreText = this.dataset.readMoreText || window.read_more_text || 'Read more';
      const readLessText = this.dataset.readLessText || window.read_less_text || 'Read less';

      if (!this.isExpanded) {
        const truncatedText = words.slice(0, this.truncateLength).join(' ') + '... ';
        this.appendChild(document.createTextNode(truncatedText));
        this.toggleButton.textContent = readMoreText;
      } else {
        this.appendChild(document.createTextNode(this.originalText));
        this.toggleButton.textContent = readLessText;
      }

      this.appendChild(this.toggleButton);
    }

    toggleTruncate(event) {
      event.preventDefault();
      this.isExpanded = !this.isExpanded;
      this.truncateContent();
    }
  }
  if (!customElements.get('cart-truncate-text')) customElements.define('cart-truncate-text', CartTruncateText);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-line-item-compact"] && !Shopify.designMode) return;
  try {
    const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if(!loader) return;
    if(state){
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease'
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease'
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => {
      if (selector && selector !== '#' && selector !== '.') {
        const el = document.querySelector(selector);
        if (el) arr.push(el);
      }
    });
    return arr;
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["complementary-area"] && !Shopify.designMode) return;
  try {
    class ComplementaryRevealList extends HTMLElement {
    connectedCallback() {
      this.extraRows = this.querySelector('[data-complementary-extra-rows]');
      this.toggleBtn = this.querySelector('[data-complementary-reveal-toggle]');
      if (!this.extraRows || !this.toggleBtn) return;

      this.label = this.toggleBtn.querySelector('[data-reveal-label]');
      this.expanded = false;
      this.animating = false;

      this.onToggleBound = this.onToggle.bind(this);
      this.toggleBtn.addEventListener('click', this.onToggleBound);
    }

    disconnectedCallback() {
      if (this.toggleBtn) {
        this.toggleBtn.removeEventListener('click', this.onToggleBound);
      }
    }

    prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    onToggle() {
      if (this.animating) return;
      if (this.expanded) {
        this.collapse();
      } else {
        this.expand();
      }
    }

    updateButtonState(expanded) {
      this.toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (this.label) {
        this.label.textContent = expanded
          ? this.toggleBtn.dataset.textCollapse
          : this.toggleBtn.dataset.textExpand;
      }
    }

    expand() {
      this.animating = true;
      this.expanded = true;
      this.extraRows.removeAttribute('inert');
      this.extraRows.removeAttribute('aria-hidden');
      this.extraRows.style.overflow = 'hidden';
      this.updateButtonState(true);

      const rows = Array.prototype.slice.call(this.extraRows.children);
      const reduceMotion = this.prefersReducedMotion();

      const run = () => {
        const targetHeight = this.extraRows.scrollHeight;

        if (window.gsap && !reduceMotion) {
          window.gsap.fromTo(
            this.extraRows,
            { height: 0 },
            {
              height: targetHeight,
              duration: 0.5,
              ease: 'power2.out',
              onComplete: () => {
                this.extraRows.style.height = 'auto';
                this.extraRows.style.overflow = 'visible';
                this.animating = false;
              }
            }
          );
          window.gsap.fromTo(
            rows,
            { opacity: 0, y: 16 },
            {
              opacity: 1,
              y: 0,
              duration: 0.4,
              stagger: 0.08,
              ease: 'power2.out',
              clearProps: 'transform'
            }
          );
        } else {
          this.extraRows.style.height = 'auto';
          this.extraRows.style.overflow = 'visible';
          this.animating = false;
        }
      };

      if (window.onThemeGsapReady) {
        window.onThemeGsapReady(run);
      } else {
        run();
      }

      const firstFocusable = rows[0] ? rows[0].querySelector('a, button, input') : null;
      if (firstFocusable) {
        try {
          firstFocusable.focus({ preventScroll: true });
        } catch (e) {
          firstFocusable.focus();
        }
      }
    }

    collapse() {
      this.animating = true;
      this.expanded = false;
      this.updateButtonState(false);

      const reduceMotion = this.prefersReducedMotion();
      const finishCollapse = () => {
        this.extraRows.setAttribute('inert', '');
        this.extraRows.setAttribute('aria-hidden', 'true');
        this.animating = false;
      };

      const run = () => {
        this.extraRows.style.height = this.extraRows.scrollHeight + 'px';
        this.extraRows.style.overflow = 'hidden';

        if (window.gsap && !reduceMotion) {
          window.gsap.to(this.extraRows, {
            height: 0,
            duration: 0.4,
            ease: 'power2.in',
            onComplete: finishCollapse
          });
        } else {
          this.extraRows.style.height = '0px';
          finishCollapse();
        }
      };

      if (window.onThemeGsapReady) {
        window.onThemeGsapReady(run);
      } else {
        run();
      }

      try {
        this.toggleBtn.focus({ preventScroll: true });
      } catch (e) {
        this.toggleBtn.focus();
      }
    }
  }

  if (!customElements.get('complementary-reveal-list')) {
    customElements.define('complementary-reveal-list', ComplementaryRevealList);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["country-localization"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class LocalizationDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.items = this.content.querySelectorAll('[data-submit-btn]');
      const doAnimate = (element) => {
        const { frames, options } = this.content.dataset;
        if (!frames || !options) return;
        try {
          element.animate(JSON.parse(frames), JSON.parse(options));
        } catch (e) {
          console.warn('LocalizationDropdown: Animation data missing or invalid', e);
        }
      };
      const select = (event) => {
        event.preventDefault();
        const form = document.getElementById(this.dataset.formId);
        const input = this.querySelector('[data-submit-input]');
        if (!input || !form) return;
        input.value = event.currentTarget.dataset.value;
        form.submit();
      };
      const onBodyClick = (event) => { if (!this.contains(event.target)) closeDropdown(); };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', 'true');
        this.content.classList.add('dropdown--open');
        doAnimate(this.content);
        this.content.focus();
        trapFocus(this.content);
        document.body.addEventListener('click', onBodyClick);
        this.addEventListener('keyup', onKeyUp);
        this.items.forEach((item) => item.addEventListener('click', select));
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', 'false');
        this.content.classList.remove('dropdown--open');
        trapFocus(null, this.button, false);
        document.body.removeEventListener('click', onBodyClick);
        this.removeEventListener('keyup', onKeyUp);
        this.items.forEach((item) => item.removeEventListener('click', select));
      };
      const onToggleClick = () => {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        isExpanded ? closeDropdown() : openDropdown();
      };
      this.button.addEventListener('click', onToggleClick);
      this._onToggleClick = onToggleClick;
      this._select = select;
      this._closeDropdown = closeDropdown;
      this.select = select;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
    disconnectedCallback() {
      if (this.button && this._onToggleClick) this.button.removeEventListener('click', this._onToggleClick);
      if (this.items && this._select) this.items.forEach((item) => item.removeEventListener('click', this._select));
      if (this._closeDropdown) this._closeDropdown();
    }
  }
  if (!customElements.get('localization-dropdown')) customElements.define('localization-dropdown', LocalizationDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-burger-logo-structure"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalBurgerMenuToggler extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-burger-menu-toggler')) customElements.define('modal-burger-menu-toggler', ModalBurgerMenuToggler);
  class ModalBurgerMenuComponent extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      const self = this;
      // GSAP slide + fade reveal for the mobile drawer, reading
      // window.themeMotion tokens instead of a hardcoded WAAPI translateX.
      const doAnimate = (onComplete) => {
        if (!self.animatorWrap || !window.gsap) {
          if (onComplete) onComplete();
          return;
        }
        var _M = window.themeMotion || {};
        window.gsap.killTweensOf(self.animatorWrap);
        window.gsap.set(self.animatorWrap, { opacity: 0, x: '-100%' });
        window.gsap.to(self.animatorWrap, {
          opacity: 1, x: '0%',
          duration: (_M.dur && _M.dur.base) || 0.4,
          ease: (_M.ease && _M.ease.ui) || 'power3.out',
          onComplete: onComplete
        });
      };
      const doAnimateOut = (onComplete) => {
        if (!self.animatorWrap || !window.gsap) {
          if (onComplete) onComplete();
          return;
        }
        var _M = window.themeMotion || {};
        window.gsap.killTweensOf(self.animatorWrap);
        window.gsap.to(self.animatorWrap, {
          opacity: 0, x: '-100%',
          duration: (_M.dur && _M.dur.fast) || 0.3,
          ease: (_M.ease && _M.ease.exit) || 'power2.in',
          onComplete: onComplete
        });
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      }
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        self.querySelectorAll('menu-dropdown').forEach((dropdown) => {
          if (dropdown.closeDropdown && dropdown.content && dropdown.content.classList.contains('dropdown--open')) {
            dropdown.closeDropdown();
          }
        });
        setListeners(false);
        doAnimateOut(() => {
          if (self.dataset.trigger !== 'self') {
            if (self.parentElement === document.body) document.body.removeChild(self);
            if (self.parent) self.parent.append(self);
          }
          setClasses(false);
          if (self.toggler) {
            self.toggler.setAttribute('data-expanded', 'false');
            trapFocus(null, self.toggler, false);
          }
          self.toggler = null;
          self.parent = null;
        });
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-burger-menu-component')) customElements.define('modal-burger-menu-component', ModalBurgerMenuComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-logo-center-structure"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalMenuToggler extends HTMLElement {
    constructor() {
      super();
      if (window.screen.width > 991) return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-menu-toggler')) customElements.define('modal-menu-toggler', ModalMenuToggler);
  class ModalMenuComponent extends HTMLElement {
    constructor() {
      super();
      if (window.screen.width > 991) return;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      if (window.screen.width > 991) return;
      const self = this;
      // GSAP slide + fade reveal for the mobile drawer, reading
      // window.themeMotion tokens instead of a hardcoded WAAPI translateX.
      const doAnimate = (onComplete) => {
        if (!self.animatorWrap || !window.gsap) {
          if (onComplete) onComplete();
          return;
        }
        var _M = window.themeMotion || {};
        window.gsap.killTweensOf(self.animatorWrap);
        window.gsap.set(self.animatorWrap, { opacity: 0, x: '-100%' });
        window.gsap.to(self.animatorWrap, {
          opacity: 1, x: '0%',
          duration: (_M.dur && _M.dur.base) || 0.4,
          ease: (_M.ease && _M.ease.ui) || 'power3.out',
          onComplete: onComplete
        });
      };
      const doAnimateOut = (onComplete) => {
        if (!self.animatorWrap || !window.gsap) {
          if (onComplete) onComplete();
          return;
        }
        var _M = window.themeMotion || {};
        window.gsap.killTweensOf(self.animatorWrap);
        window.gsap.to(self.animatorWrap, {
          opacity: 0, x: '-100%',
          duration: (_M.dur && _M.dur.fast) || 0.3,
          ease: (_M.ease && _M.ease.exit) || 'power2.in',
          onComplete: onComplete
        });
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      }
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        self.querySelectorAll('menu-dropdown').forEach((dropdown) => {
          if (dropdown.closeDropdown && dropdown.content && dropdown.content.classList.contains('dropdown--open')) {
            dropdown.closeDropdown();
          }
        });
        setListeners(false);
        doAnimateOut(() => {
          if (self.dataset.trigger !== 'self') {
            if (self.parentElement === document.body) document.body.removeChild(self);
            if (self.parent) self.parent.append(self);
          }
          setClasses(false);
          if (self.toggler) {
            self.toggler.setAttribute('data-expanded', 'false');
            trapFocus(null, self.toggler, false);
          }
          self.toggler = null;
          self.parent = null;
        });
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-menu-component')) customElements.define('modal-menu-component', ModalMenuComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-localization"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class LocalizationDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.items = this.content.querySelectorAll('[data-submit-btn]');
      const doAnimate = (element) => {
        const { frames, options } = this.content.dataset;
        if (!frames || !options) return;
        try {
          element.animate(JSON.parse(frames), JSON.parse(options));
        } catch (e) {
          console.warn('LocalizationDropdown: Animation data missing or invalid', e);
        }
      };
      const select = (event) => {
        event.preventDefault();
        const form = document.getElementById(this.dataset.formId);
        const input = this.querySelector('[data-submit-input]');
        if (!input || !form) return;
        input.value = event.currentTarget.dataset.value;
        form.submit();
      };
      const onBodyClick = (event) => { if (!this.contains(event.target)) closeDropdown(); };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', 'true');
        this.content.classList.add('dropdown--open');
        doAnimate(this.content);
        this.content.focus();
        trapFocus(this.content);
        document.body.addEventListener('click', onBodyClick);
        this.addEventListener('keyup', onKeyUp);
        this.items.forEach((item) => item.addEventListener('click', select));
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', 'false');
        this.content.classList.remove('dropdown--open');
        trapFocus(null, this.button, false);
        document.body.removeEventListener('click', onBodyClick);
        this.removeEventListener('keyup', onKeyUp);
        this.items.forEach((item) => item.removeEventListener('click', select));
      };
      const onToggleClick = () => {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        isExpanded ? closeDropdown() : openDropdown();
      };
      this.button.addEventListener('click', onToggleClick);
      this._onToggleClick = onToggleClick;
      this._select = select;
      this._closeDropdown = closeDropdown;
      this.select = select;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
    disconnectedCallback() {
      if (this.button && this._onToggleClick) this.button.removeEventListener('click', this._onToggleClick);
      if (this.items && this._select) this.items.forEach((item) => item.removeEventListener('click', this._select));
      if (this._closeDropdown) this._closeDropdown();
    }
  }
  if (!customElements.get('localization-dropdown')) customElements.define('localization-dropdown', LocalizationDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["line-item-compact"] && !Shopify.designMode) return;
  try {
    const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => {
      if (selector && selector !== '#' && selector !== '.') {
        const el = document.querySelector(selector);
        if (el) arr.push(el);
      }
    });
    return arr;
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-dropdown"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MegaMenuDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('mega-menu-dropdown[data-level="1"]') || this.closest('menu-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      // GSAP fade + drop reveal, reading window.themeMotion tokens instead of
      // a hardcoded WAAPI opacity fade — matches the pacing of every other
      // GSAP-driven reveal in the theme instead of a flat 300ms ease.
      const doAnimate = () => {
        if (!window.gsap) return null;
        var _M = window.themeMotion || {};
        window.gsap.killTweensOf(this.content);
        if (window.innerWidth < 992) {
          window.gsap.set(this.content, { opacity: 0, x: 24 });
          return window.gsap.to(this.content, {
            opacity: 1, x: 0,
            duration: (_M.dur && _M.dur.base) || 0.4,
            ease: (_M.ease && _M.ease.ui) || 'power3.out'
          });
        }
        window.gsap.set(this.content, { opacity: 0, y: -8 });
        return window.gsap.to(this.content, {
          opacity: 1, y: 0,
          duration: (_M.dur && _M.dur.fast) || 0.3,
          ease: (_M.ease && _M.ease.ui) || 'power3.out'
        });
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        this.content.style.top = '';
        const otherOpen = document.querySelectorAll('.dropdown--open');
        if (otherOpen.length === 0) {
          document.body.classList.remove('overflow-hidden');
          const headerFixedArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
          if (headerFixedArea) headerFixedArea.classList.remove('is-header-open');
        }
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content && this.onParentScroll) outerSelf.content.removeEventListener('scroll', this.onParentScroll);
          if (window.innerWidth < 992 && outerSelf.content) outerSelf.content.style.overflowY = 'auto';
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.button.focus();
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        this.content.style.position = '';
        this.content.style.marginTop = '';
        this.content.style.maxHeight = '';
        this.content.style.overflowY = '';
        this.content.style.top = '';
        this.content.style.left = '';
        document.body.classList.add('overflow-hidden');
        const headerFixedArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
        if (headerFixedArea) headerFixedArea.classList.add('is-header-open');
        if (window.innerWidth > 991) {
          if (!isLevel2) {
            const rect = this.content.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const padding = 15;
            if (rect.bottom > viewportHeight) {
              this.content.style.maxHeight = `${Math.max(100, viewportHeight - rect.top - padding)}px`;
              this.content.style.overflowY = 'auto';
            }
          }
        } else {
          this.content.style.maxHeight = '100vh';
          this.content.style.overflowY = 'auto';
          if (isLevel2 && outerSelf && outerSelf.content) {
            this.content.style.top = `${outerSelf.content.scrollTop}px`;
            outerSelf.content.style.overflowY = 'hidden';
          }
          this.content.scrollTop = 0;
        }
        const animation = doAnimate();
        if (animation) {
          const originalOverflow = this.content.style.overflowY;
          this.content.style.overflowY = 'hidden';
          animation.then(() => {
            this.content.style.overflowY = originalOverflow || '';
          });
        }
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('mega-menu-dropdown')) customElements.define('mega-menu-dropdown', MegaMenuDropdown);
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.marquee-component');
      if (!container || !this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('marquee-component')) customElements.define('marquee-component', MarqueeComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-dropdown"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MenuDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('menu-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      // GSAP fade + drop reveal, reading window.themeMotion tokens instead of
      // a hardcoded WAAPI opacity fade — matches the pacing of every other
      // GSAP-driven reveal in the theme instead of a flat 300ms ease.
      const doAnimate = () => {
        if (!window.gsap) return null;
        var _M = window.themeMotion || {};
        window.gsap.killTweensOf(this.content);
        if (window.innerWidth < 992) {
          window.gsap.set(this.content, { opacity: 0, x: 24 });
          return window.gsap.to(this.content, {
            opacity: 1, x: 0,
            duration: (_M.dur && _M.dur.base) || 0.4,
            ease: (_M.ease && _M.ease.ui) || 'power3.out'
          });
        }
        window.gsap.set(this.content, { opacity: 0, y: -8 });
        return window.gsap.to(this.content, {
          opacity: 1, y: 0,
          duration: (_M.dur && _M.dur.fast) || 0.3,
          ease: (_M.ease && _M.ease.ui) || 'power3.out'
        });
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        this.content.style.top = '';
        const otherOpen = document.querySelectorAll('.dropdown--open');
        if (otherOpen.length === 0) {
          document.body.classList.remove('overflow-hidden');
          const headerFixedArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
          if (headerFixedArea) headerFixedArea.classList.remove('is-header-open');
        }
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content && this.onParentScroll) outerSelf.content.removeEventListener('scroll', this.onParentScroll);
          if (window.innerWidth < 992 && outerSelf.content) outerSelf.content.style.overflowY = 'auto';
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        this.button.focus();
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        this.content.style.position = '';
        this.content.style.marginTop = '';
        this.content.style.maxHeight = '';
        this.content.style.overflowY = '';
        this.content.style.top = '';
        this.content.style.left = '';
        document.body.classList.add('overflow-hidden');
        const headerFixedArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
        if (headerFixedArea) headerFixedArea.classList.add('is-header-open');
        if (window.innerWidth > 991) {
          const rect = this.content.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const padding = 15;
          if (rect.right > window.innerWidth) {
            this.content.style.left = 'auto';
            this.content.style.right = 'calc(100% + 5px)';
          }
          if (rect.bottom > viewportHeight && !isLevel2) {
            this.content.style.maxHeight = `${Math.max(100, viewportHeight - rect.top - padding)}px`;
            this.content.style.overflowY = 'auto';
          }
        } else {
          this.content.style.maxHeight = '100vh';
          this.content.style.overflowY = 'auto';
          if (isLevel2 && outerSelf && outerSelf.content) {
            this.content.style.top = `${outerSelf.content.scrollTop}px`;
            outerSelf.content.style.overflowY = 'hidden';
          }
          this.content.scrollTop = 0;
        }
        const animation = doAnimate();
        if (animation) {
          const originalOverflow = this.content.style.overflowY;
          this.content.style.overflowY = 'hidden';
          animation.then(() => {
            this.content.style.overflowY = originalOverflow || '';
          });
        }
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('menu-dropdown')) customElements.define('menu-dropdown', MenuDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pickup-options"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalPickupToggler extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-pickup-toggler')) customElements.define('modal-pickup-toggler', ModalPickupToggler);
  class ModalPickupComponent extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      const self = this;
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      }
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-pickup-component')) customElements.define('modal-pickup-component', ModalPickupComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.marquee-component');
      if (!container || !this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('marquee-component')) customElements.define('marquee-component', MarqueeComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-showcase-reel-card"] && !Shopify.designMode) return;
  try {
    class DeferredMedia extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-deferred-media-toggler]');
      this.template = this.querySelector('template');
      const loadMedia = () => {
        if (this.dataset.onHover !== 'true' && typeof window.pauseElementBasedMedia === 'function') {
          window.pauseElementBasedMedia(document.body, this);
        }
        if (this.getAttribute('loaded') === 'true') return;
        this.setAttribute('loaded', 'true');
        if (this.template) {
          const content = this.template.content.cloneNode(true);
          this.appendChild(content);
        }
        const mediaElement = this.querySelector('video, iframe');
        if (mediaElement) {
          if (mediaElement.tagName === 'VIDEO') {
            mediaElement.playsInline = true;
            mediaElement.setAttribute('playsinline', '');
            mediaElement.setAttribute('webkit-playsinline', '');
            if (!mediaElement.getAttribute('src')) {
              const source = mediaElement.querySelector('source');
              if (source && (source.src || source.getAttribute('src'))) {
                mediaElement.src = source.src || source.getAttribute('src');
              }
            }
            mediaElement.load();
            const playPromise = mediaElement.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                mediaElement.muted = true;
                mediaElement.setAttribute('muted', '');
                mediaElement.play().catch(() => {});
              });
            }
          } else if (mediaElement.tagName === 'IFRAME') {
            const src = mediaElement.getAttribute('src');
            if (src && !src.includes('autoplay')) {
              mediaElement.setAttribute('src', src.includes('?') ? `${src}&autoplay=1` : `${src}?autoplay=1`);
            }
          }
        }
      };
      this.loadMediaHandler = loadMedia;
      if (this.button) this.button.addEventListener('click', this.loadMediaHandler);
    }
    disconnectedCallback() {
      const cleanUp = () => {
        if (this.button && this.loadMediaHandler) this.button.removeEventListener('click', this.loadMediaHandler);
      };
      cleanUp();
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promo-card"] && !Shopify.designMode) return;
  try {
    class DeferredMedia extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-deferred-media-toggler]');
      this.caption = this.querySelector('.promo-card_caption');
      this.template = this.querySelector('template');
      const loadMedia = () => {
        if (this.dataset.onHover !== 'true' && typeof window.pauseElementBasedMedia === 'function') {
          window.pauseElementBasedMedia(document.body, this);
        }
        if (this.getAttribute('loaded') === 'true') return;
        this.setAttribute('loaded', 'true');
        if (this.template) {
          const content = this.template.content.cloneNode(true);
          this.appendChild(content);
        }
        const mediaElement = this.querySelector('video, iframe');
        if (mediaElement) {
          if (mediaElement.tagName === 'VIDEO') {
            mediaElement.playsInline = true;
            mediaElement.setAttribute('playsinline', '');
            mediaElement.setAttribute('webkit-playsinline', '');
            if (!mediaElement.getAttribute('src')) {
              const source = mediaElement.querySelector('source');
              if (source && (source.src || source.getAttribute('src'))) {
                mediaElement.src = source.src || source.getAttribute('src');
              }
            }
            mediaElement.load();
            mediaElement.muted = true;
            mediaElement.controls = false;
            mediaElement.play().catch(() => {});
          } else if (mediaElement.tagName === 'IFRAME') {
            const src = mediaElement.getAttribute('src');
            if (src && !src.includes('autoplay')) {
              mediaElement.setAttribute('src', src.includes('?') ? `${src}&autoplay=1` : `${src}?autoplay=1`);
            }
          }
        }
      };
      this.loadMediaHandler = loadMedia;
      if (this.buttons.length) {
        this.buttons.forEach((btn) => btn.addEventListener('click', this.loadMediaHandler));
      }
      if (this.caption) {
        this.captionHandler = (e) => {
          if (e.target.closest('a, button, input')) return;
          this.loadMediaHandler();
        };
        this.caption.addEventListener('click', this.captionHandler);
      }
    }
    disconnectedCallback() {
      const cleanUp = () => {
        if (this.buttons && this.buttons.length && this.loadMediaHandler) {
          this.buttons.forEach((btn) => btn.removeEventListener('click', this.loadMediaHandler));
        }
        if (this.caption && this.captionHandler) {
          this.caption.removeEventListener('click', this.captionHandler);
        }
      };
      cleanUp();
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-dropdown"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
  };
  class SearchDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.resultsArea = this.querySelector('[data-render-predict-results]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      // GSAP fade + drop reveal, reading window.themeMotion tokens instead of
      // a hardcoded WAAPI opacity fade.
      const doAnimate = () => {
        if (!window.gsap) return;
        var _M = window.themeMotion || {};
        window.gsap.killTweensOf(this.content);
        window.gsap.set(this.content, { opacity: 0, y: -8 });
        window.gsap.to(this.content, {
          opacity: 1, y: 0,
          duration: (_M.dur && _M.dur.fast) || 0.3,
          ease: (_M.ease && _M.ease.ui) || 'power3.out'
        });
      };
      const setupPredictiveSearch = () => {
        if (this.predictiveInitialized) return;
        this.input = this.querySelector('[data-predictives="true"]');
        this.predictiveInitialized = true;
        this.form = this.querySelector('form');
        this.cachedResults = [];
        if (window.AbortController) this.abortController = new AbortController();
        this.resultsContainers = {};
        this.initHtml = {};
        try {
          const arrSelectors = JSON.parse(this.dataset.renders || '[]');
          arrSelectors.forEach((selector) => {
            const element = document.querySelector(selector);
            if (element) {
              this.resultsContainers[selector] = element;
              this.initHtml[selector] = element.innerHTML;
            }
          });
        } catch (e) {
          console.error('Expected JSON in data-renders:', e);
        }
        const debounce = (fn, wait) => {
          let t;
          return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
          };
        };
        const onSubmit = (event) => {
          event.preventDefault();
          this.form.submit();
        };
        this.onSubmit = onSubmit;
        const fetchSearchResults = (terms) => {
          fetch(`${window.routes?.predictive_search_url || '/search/suggest'}?q=${encodeURIComponent(terms)}&section_id=predictive-organizer&resources[type]=${this.dataset.searchTypes}`, {
            signal: this.abortController?.signal,
          })
            .then((response) => {
              if (!response.ok) {
                var error = new Error(response.status);
                throw error;
              }
              return response.text();
            })
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const searchObj = {
                searchTerm: this.searchTerm,
                contentHtml: html,
              };
              this.cachedResults.push(searchObj);
              const arr = JSON.parse(this.dataset.renders || '[]');
              arr.forEach((selector) => {
                const element = document.querySelector(selector);
                if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
              });
              this.btnSubmit = this.querySelector('[data-btn-submit]');
              if (this.btnSubmit) this.btnSubmit.addEventListener('click', this.onSubmit);
            })
            .catch((error) => {
              if (error?.code === 20) {
                throw error;
              }
            });
        };
        const showCachedResults = (data, cache) => {
          const cacheDataArr = cache;
          const cachedResults = cacheDataArr.find((results) => results.searchTerm === data.searchTerm);
          const arr = JSON.parse(this.dataset.renders || '[]');
          arr.forEach((selector) => {
            const element = document.querySelector(selector);
            if (element && cachedResults.contentHtml.querySelector(selector))
              element.innerHTML = cachedResults.contentHtml.querySelector(selector).innerHTML;
          });
        };
        const toggleResultsView = (showPredictive) => {
          const defaultResults = this.querySelector('[data-default-results]');
          const predictResults = this.querySelector('[data-render-predict-results]');
          if (showPredictive) {
            if (defaultResults) defaultResults.style.display = 'none';
            if (predictResults) predictResults.style.display = 'block';
          } else {
            if (defaultResults) defaultResults.style.display = 'block';
            if (predictResults) predictResults.style.display = 'none';
          }
        };
        const resetResults = (clearInput = false) => {
          this.searchTerm = '';
          if (clearInput && this.input) this.input.value = '';
          for (const key in this.resultsContainers) {
            const container = this.resultsContainers[key];
            if (container) container.innerHTML = this.initHtml[key] || '';
          }
          toggleResultsView(false);
        };
        this.resetResults = resetResults;
        const onInputType = (event) => {
          const inputValueTerm = this.input ? this.input.value.replace(/\s/g, '') : '';
          if (inputValueTerm.length > 0) {
            toggleResultsView(true);
            this.searchTerm = this.input.value.trim();
            const term = { searchTerm: this.searchTerm };
            if (!this.cachedResults || !this.cachedResults.some((key) => key.searchTerm === term.searchTerm)) {
              fetchSearchResults(this.searchTerm);
              return;
            }
            showCachedResults(term, this.cachedResults);
            return;
          }
          toggleResultsView(false);
          resetResults();
        };
        this.input.addEventListener('input', debounce(onInputType, 500));
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        const otherOpen = document.querySelectorAll('.dropdown--open');
        if (otherOpen.length === 0) {
          document.body.classList.remove('overflow-hidden');
          const headerFixedArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
          if (headerFixedArea) headerFixedArea.classList.remove('is-header-open');
        }
        trapFocus(null, this.button, false);
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        if (this.resetResults) this.resetResults(true);
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        document.body.classList.add('overflow-hidden');
        const headerFixedArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
        if (headerFixedArea) headerFixedArea.classList.add('is-header-open');
        doAnimate();
        trapFocus(this.content, this.input || this.content);
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        const inputPredictive = this.querySelector('[data-predictives="true"]');
        if (inputPredictive) setupPredictiveSearch();
      };
      const onBodyClick = (event) => {
        if (!this.contains(event.target)) closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') {
          closeDropdown();
        } else {
          openDropdown();
        }
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.button.addEventListener('click', this.onButtonClick);
      if (this.closeButton) this.closeButton.addEventListener('click', closeDropdown);
      if (this.dataset.predictives === 'true' && this.input) {
        setupPredictiveSearch();
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }
  }
  if (!customElements.get('tabset-component')) {
    class TabsetComponent extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.tablistNode = this;
        this.tabs = Array.from(this.tablistNode.querySelectorAll('[data-tabset-content]'));
        const animationFrames = (() => {
          try { return JSON.parse(this.dataset.frames); } catch (e) { return null; }
        })();
        const timing = (() => {
          try { return JSON.parse(this.dataset.options); } catch (e) { return null; }
        })();
        const doAnimate = (node) => {
          if (!animationFrames || !timing || !node) return;
          return node.animate(animationFrames, timing);
        };
        const setSelectedTab = (currentTab, setFocus = true) => {
          this.tabs.forEach((tab, index) => {
            const panel = this.tabpanels[index];
            if (!panel) return;
            const isSelected = currentTab === tab;
            tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            tab.tabIndex = isSelected ? 0 : -1;
            panel.classList.toggle('hidden', !isSelected);
            if (isSelected) {
              if (setFocus) tab.focus();
              doAnimate(panel);
            }
          });
          window.dispatchEvent(new Event('resize'));
        };
        const setSelectedToPreviousTab = (currentTab) => {
          const index = this.tabs.indexOf(currentTab);
          this.setSelectedTab(index === 0 ? this.lastTab : this.tabs[index - 1]);
        };
        const setSelectedToNextTab = (currentTab) => {
          const index = this.tabs.indexOf(currentTab);
          this.setSelectedTab(index === this.tabs.length - 1 ? this.firstTab : this.tabs[index + 1]);
        };
        const onKeydown = (event) => {
          const tgt = event.currentTarget;
          let flag = false;
          switch (event.key) {
            case 'ArrowLeft':
              this.setSelectedToPreviousTab(tgt);
              flag = true;
              break;
            case 'ArrowRight':
              this.setSelectedToNextTab(tgt);
              flag = true;
              break;
            case 'Home':
              this.setSelectedTab(this.firstTab);
              flag = true;
              break;
            case 'End':
              this.setSelectedTab(this.lastTab);
              flag = true;
              break;
            default:
              break;
          }
          if (flag) {
            event.stopPropagation();
            event.preventDefault();
          }
        };
        const onClick = (event) => {
          this.setSelectedTab(event.currentTarget);
        };
        const initialize = () => {
          this.tabpanels = this.tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
          this.tabs.forEach(tab => {
            tab.tabIndex = -1;
            tab.setAttribute('aria-selected', 'false');
            tab.addEventListener('keydown', onKeydown);
            tab.addEventListener('click', onClick);
          });
          this.firstTab = this.tabs[0];
          this.lastTab = this.tabs[this.tabs.length - 1];
          this.setSelectedTab(this.firstTab, false);
        };
        this.setSelectedTab = setSelectedTab;
        this.setSelectedToPreviousTab = setSelectedToPreviousTab;
        this.setSelectedToNextTab = setSelectedToNextTab;
        this.onKeydown = onKeydown;
        this.onClick = onClick;
        this.initialize = initialize;
        if (this.dataset.editorMode === 'true') {
          document.addEventListener('shopify:block:select', (event) => {
            const target = event.target;
            const parent = target.parentElement;
            if (parent.nodeName !== 'TABSET-COMPONENT') return;
            parent.initialize();
            parent.setSelectedTab(target);
          });
        }
        initialize();
      }
    }
    customElements.define('tabset-component', TabsetComponent);
  }
  if (!customElements.get('search-dropdown')) customElements.define('search-dropdown', SearchDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };

  class ModalSearchToggler extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        if (modal && typeof modal.open === 'function') {
          modal.open(this.button);
          this.button.setAttribute('data-expanded', 'true');
        }
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (!modal) return;
        if (this.button.dataset.expanded === 'true') {
          if (typeof modal.close === 'function') modal.close();
          return;
        }
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-search-toggler')) customElements.define('modal-search-toggler', ModalSearchToggler);

  class ModalSearchComponent extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }

    connectedCallback() {
      const self = this;
      this.input = this.querySelector('[data-search-input]');
      this.clearBtn = this.querySelector('[data-search-clear-btn]');
      this.form = this.querySelector('form');

      const doAnimate = (onComplete) => {
        if (!self.animatorWrap) {
          if (onComplete) onComplete();
          return;
        }
        if (window.gsap) {
          var _M = window.themeMotion || {};
          window.gsap.killTweensOf(self.animatorWrap);
          window.gsap.set(self.animatorWrap, { opacity: 0, y: -15 });
          window.gsap.to(self.animatorWrap, {
            opacity: 1, y: 0,
            duration: (_M.dur && _M.dur.base) || 0.35,
            ease: (_M.ease && _M.ease.ui) || 'power3.out',
            onComplete: onComplete
          });
        } else {
          const parseJSON = (key) => {
            try {
              return JSON.parse(self.animatorWrap.dataset[key]);
            } catch (e) {
              return null;
            }
          };
          const animationFrames = parseJSON('frames');
          const timing = parseJSON('options');
          if (animationFrames && timing) {
            self.animatorWrap.animate(animationFrames, timing);
          }
          if (onComplete) onComplete();
        }
      };

      const doAnimateOut = (onComplete) => {
        if (!self.animatorWrap || !window.gsap) {
          if (onComplete) onComplete();
          return;
        }
        var _M = window.themeMotion || {};
        window.gsap.killTweensOf(self.animatorWrap);
        window.gsap.to(self.animatorWrap, {
          opacity: 0, y: -10,
          duration: (_M.dur && _M.dur.fast) || 0.25,
          ease: (_M.ease && _M.ease.exit) || 'power2.in',
          onComplete: onComplete
        });
      };

      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };

      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };

      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };

      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };

      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      };

      const setupPredictiveSearch = () => {
        if (this.predictiveInitialized) return;
        this.predictiveInitialized = true;
        this.cachedResults = [];
        if (window.AbortController) this.abortController = new AbortController();
        this.resultsContainers = {};
        this.initHtml = {};

        try {
          const arrSelectors = JSON.parse(this.dataset.renders || '[]');
          arrSelectors.forEach((selector) => {
            const element = this.querySelector(selector);
            if (element) {
              this.resultsContainers[selector] = element;
              this.initHtml[selector] = element.innerHTML;
            }
          });
        } catch (e) {
          console.error('Expected JSON in data-renders:', e);
        }

        const debounce = (fn, wait) => {
          let t;
          return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
          };
        };

        const onSubmit = (event) => {
          event.preventDefault();
          if (this.form) this.form.submit();
        };
        this.onSubmit = onSubmit;

        const syncActiveTabPanel = () => {
          const tabset = this.querySelector('tabset-component');
          if (tabset && typeof tabset.setSelectedTab === 'function') {
            const activeTab = tabset.querySelector('[aria-selected="true"]') || tabset.tabs?.[0];
            if (activeTab) tabset.setSelectedTab(activeTab, false);
          }
        };

        const fetchSearchResults = (terms) => {
          this.btnSubmit = this.querySelector('[data-btn-submit]');
          if (this.btnSubmit) this.btnSubmit.classList.add('btn-loading');
          const resultsContainer = this.querySelector('[data-render-predict-results]');
          if (resultsContainer) resultsContainer.classList.add('is-loading');
          const searchTypes = this.dataset.searchTypes || 'query,product,collection,page,article';
          if (this.abortController) {
            this.abortController.abort();
            this.abortController = new AbortController();
          }
          fetch(`${window.routes?.predictive_search_url || '/search/suggest'}?q=${encodeURIComponent(terms)}&section_id=predictive-organizer&resources[type]=${searchTypes}`, {
            signal: this.abortController?.signal,
          })
            .then((response) => {
              if (!response.ok) {
                var error = new Error(response.status);
                throw error;
              }
              return response.text();
            })
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const searchObj = {
                searchTerm: terms,
                contentHtml: html,
              };
              this.cachedResults.push(searchObj);
              if (this.searchTerm !== terms || !this.input || !this.input.value.trim()) {
                return;
              }
              const arr = JSON.parse(this.dataset.renders || '["[data-render-predict-results]"]');
              arr.forEach((selector) => {
                const element = this.querySelector(selector);
                const fetchedElement = html.querySelector(selector);
                if (element && fetchedElement) element.innerHTML = fetchedElement.innerHTML;
              });
              syncActiveTabPanel();
              this.btnSubmit = this.querySelector('[data-btn-submit]');
              if (this.btnSubmit) this.btnSubmit.addEventListener('click', this.onSubmit);
            })
            .catch((error) => {
              if (error?.code === 20 || error?.name === 'AbortError') {
                return;
              }
            })
            .finally(() => {
              if (this.btnSubmit) this.btnSubmit.classList.remove('btn-loading');
              if (resultsContainer) resultsContainer.classList.remove('is-loading');
            });
        };

        const showCachedResults = (data, cache) => {
          this.btnSubmit = this.querySelector('[data-btn-submit]');
          if (this.btnSubmit) this.btnSubmit.classList.remove('btn-loading');
          const resultsContainer = this.querySelector('[data-render-predict-results]');
          if (resultsContainer) resultsContainer.classList.remove('is-loading');
          const cachedResults = cache.find((results) => results.searchTerm === data.searchTerm);
          if (!cachedResults) return;
          const arr = JSON.parse(this.dataset.renders || '["[data-render-predict-results]"]');
          arr.forEach((selector) => {
            const element = this.querySelector(selector);
            const cachedElement = cachedResults.contentHtml.querySelector(selector);
            if (element && cachedElement) {
              element.innerHTML = cachedElement.innerHTML;
            }
          });
          syncActiveTabPanel();
          this.btnSubmit = this.querySelector('[data-btn-submit]');
          if (this.btnSubmit) this.btnSubmit.addEventListener('click', this.onSubmit);
        };

        const resetResults = (clearInput = false) => {
          this.searchTerm = '';
          this.btnSubmit = this.querySelector('[data-btn-submit]');
          if (this.btnSubmit) this.btnSubmit.classList.remove('btn-loading');
          const resultsContainer = this.querySelector('[data-render-predict-results]');
          if (resultsContainer) resultsContainer.classList.remove('is-loading');
          if (this.abortController) {
            this.abortController.abort();
            this.abortController = new AbortController();
          }
          if (clearInput && this.input) this.input.value = '';
          for (const key in this.resultsContainers) {
            const container = this.resultsContainers[key];
            if (container) {
              container.innerHTML = this.initHtml[key] || '';
              container.style.display = '';
            }
          }
          syncActiveTabPanel();
        };
        this.resetResults = resetResults;

        const onInputType = () => {
          const inputValueTerm = this.input ? this.input.value.replace(/\s/g, '') : '';
          if (inputValueTerm.length > 0) {
            this.searchTerm = this.input.value.trim();
            const term = { searchTerm: this.searchTerm };
            if (!this.cachedResults || !this.cachedResults.some((key) => key.searchTerm === term.searchTerm)) {
              fetchSearchResults(this.searchTerm);
              return;
            }
            showCachedResults(term, this.cachedResults);
            return;
          }
          resetResults();
        };

        if (this.input) {
          this.input.addEventListener('input', debounce(onInputType, 400));
        }
        if (this.clearBtn) {
          this.clearBtn.addEventListener('click', () => {
            resetResults(true);
            if (this.input) this.input.focus();
          });
        }
      };

      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.container === 'body' && self.parentElement !== document.body) {
          document.body.append(self);
        }
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content, self.input || self.content);
        setListeners(true);
        if (self.dataset.searchTypes && self.input) {
          setupPredictiveSearch();
        }
      };

      const close = () => {
        setListeners(false);
        doAnimateOut(() => {
          if (self.dataset.container === 'body' && self.parentElement === document.body) {
            document.body.removeChild(self);
            if (self.parent) self.parent.append(self);
          }
          setClasses(false);
          if (self.toggler) {
            self.toggler.setAttribute('data-expanded', 'false');
            trapFocus(null, self.toggler, false);
          }
          self.toggler = null;
          self.parent = null;
          if (self.resetResults) self.resetResults(true);
        });
      };

      this.open = open;
      this.close = close;

      if (this.dataset.searchTypes && this.input) {
        setupPredictiveSearch();
      }
    }

    disconnectedCallback() {
      if (this.setListeners) this.setListeners(false);
    }
  }
  if (!customElements.get('modal-search-component')) customElements.define('modal-search-component', ModalSearchComponent);

  if (!customElements.get('tabset-component')) {
    class TabsetComponent extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.tablistNode = this;
        this.tabs = Array.from(this.tablistNode.querySelectorAll('[data-tabset-content]'));
        const animationFrames = (() => {
          try { return JSON.parse(this.dataset.frames); } catch (e) { return null; }
        })();
        const timing = (() => {
          try { return JSON.parse(this.dataset.options); } catch (e) { return null; }
        })();
        const doAnimate = (node) => {
          if (!animationFrames || !timing || !node) return;
          return node.animate(animationFrames, timing);
        };
        const setSelectedTab = (currentTab, setFocus = true) => {
          this.tabs.forEach((tab, index) => {
            const panel = document.getElementById(tab.getAttribute('aria-controls')) || (this.tabpanels && this.tabpanels[index]);
            const isSelected = currentTab === tab;
            tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            tab.tabIndex = isSelected ? 0 : -1;
            if (panel) {
              panel.classList.toggle('hidden', !isSelected);
              if (isSelected) {
                if (setFocus) tab.focus();
                doAnimate(panel);
              }
            }
          });
          window.dispatchEvent(new Event('resize'));
        };
        const setSelectedToPreviousTab = (currentTab) => {
          const index = this.tabs.indexOf(currentTab);
          this.setSelectedTab(index === 0 ? this.lastTab : this.tabs[index - 1]);
        };
        const setSelectedToNextTab = (currentTab) => {
          const index = this.tabs.indexOf(currentTab);
          this.setSelectedTab(index === this.tabs.length - 1 ? this.firstTab : this.tabs[index + 1]);
        };
        const onKeydown = (event) => {
          const tgt = event.currentTarget;
          let flag = false;
          switch (event.key) {
            case 'ArrowLeft':
              this.setSelectedToPreviousTab(tgt);
              flag = true;
              break;
            case 'ArrowRight':
              this.setSelectedToNextTab(tgt);
              flag = true;
              break;
            case 'Home':
              this.setSelectedTab(this.firstTab);
              flag = true;
              break;
            case 'End':
              this.setSelectedTab(this.lastTab);
              flag = true;
              break;
            default:
              break;
          }
          if (flag) {
            event.stopPropagation();
            event.preventDefault();
          }
        };
        const onClick = (event) => {
          this.setSelectedTab(event.currentTarget);
        };
        const initialize = () => {
          this.tabpanels = this.tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
          this.tabs.forEach(tab => {
            tab.tabIndex = -1;
            tab.setAttribute('aria-selected', 'false');
            tab.addEventListener('keydown', onKeydown);
            tab.addEventListener('click', onClick);
          });
          this.firstTab = this.tabs[0];
          this.lastTab = this.tabs[this.tabs.length - 1];
          this.setSelectedTab(this.firstTab, false);
        };
        this.setSelectedTab = setSelectedTab;
        this.setSelectedToPreviousTab = setSelectedToPreviousTab;
        this.setSelectedToNextTab = setSelectedToNextTab;
        this.onKeydown = onKeydown;
        this.onClick = onClick;
        this.initialize = initialize;
        if (this.dataset.editorMode === 'true') {
          document.addEventListener('shopify:block:select', (event) => {
            const target = event.target;
            const parent = target.parentElement;
            if (parent.nodeName !== 'TABSET-COMPONENT') return;
            parent.initialize();
            parent.setSelectedTab(target);
          });
        }
        initialize();
      }
    }
    customElements.define('tabset-component', TabsetComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["socials-share"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class DropdownComponent extends HTMLElement {
    constructor() {
      super();
      if(this.dataset.desktopHidden === 'true' && window.screen.width > 767) return;
      if(this.dataset.desktopHidden === 'wide' && window.screen.width > 991) return;
      this.button = this.querySelector('.dropdown-component_opener');
      this.content = this.querySelector('.dropdown-component_wrapper');
      if(!this.button || !this.content) return;
      this.onButtonClick = this.toggleDropdown.bind(this);
      this.onButtonClose = this.close.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.button.addEventListener('click', this.onButtonClick);
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if(this.closeButton) this.closeButton.addEventListener('click', this.onButtonClose);
      if(this.dataset.onHover === 'true' && window.screen.width > 1025){
        this.addEventListener('mouseenter', this.onButtonClick);
        this.addEventListener('mouseleave', this.onButtonClose);
      }
    }

    open(){
      this.button.setAttribute('aria-expanded', true);
      this.content.classList.add('dropdown--open');
      this.content.focus();
      trapFocus(this.content);
      document.body.addEventListener('click', this.onBodyClick);
      this.addEventListener('keyup', this.onKeyUp);
    }

    close(){
      this.button.setAttribute('aria-expanded', false);
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.content, false);
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    toggleDropdown(event){
      if(event.target.getAttribute('aria-expanded') === 'true') return this.close();
      this.open();
    }

    onBodyClick(event){
      const target = event.target;
      if(this.contains(target) || target === this || target === this.button
        && this.button.getAttribute('aria-expanded') === 'true') return;
      this.doClose(event);
    }

    onKeyUp(event){
      if(event.key !== 'Escape') return;
      this.doClose(event);
    }

    doClose(event){
      if(this.dataset.level === '2'){
        event.stopPropagation();
        this.close();
        this.button.focus();
        const parentDropdown = this.closest('dropdown-component[data-level="1"]');
        if(parentDropdown && parentDropdown.content) trapFocus(parentDropdown.content);
        return;
      }
      this.close();
      this.button.focus();
    }
  }
  if(!customElements.get('dropdown-component')) customElements.define('dropdown-component', DropdownComponent);

  class ShareDropdown extends DropdownComponent {
    constructor() {
      super();

      this.urlInput = this.querySelector('.shareUrl');
      if(navigator.share){
        this.button.removeEventListener('click', this.onButtonClick);
        this.button.addEventListener('click', () => { navigator.share({ url: this.urlInput.value, title: document.title }); });
        this.classList.add('--share-native');
        return;
      }
      this.classList.remove('--share-native');
      this.successMessage = this.querySelector('.shareMessage');
      this.shareButton = this.querySelector('.share-button__copy');
      this.label = this.querySelector('.share-button__label');
      if(this.shareButton) this.shareButton.addEventListener('click', this.copyToClipboard.bind(this));
    }

    toggleDetails(){
      if(this.successMessage) {
        this.successMessage.classList.add('hidden');
        this.successMessage.textContent = '';
      }
      if(this.closeButton) this.closeButton.classList.add('hidden');
      if(this.label) this.label.classList.remove('hidden');
    }

    copyToClipboard(){
      if(!this.urlInput) return;
      navigator.clipboard.writeText(this.urlInput.value).then(() => {
        if(this.successMessage) {
          this.successMessage.classList.remove('hidden');
          this.successMessage.textContent = window.accessibilityStrings?.shareSuccess || 'Link copied to clipboard';
        }
        if(this.closeButton) this.closeButton.classList.remove('hidden');
        if(this.label) this.label.classList.add('hidden');
      });
    }

    close(){
      super.close();
      this.toggleDetails();
    }
  }
  if(!customElements.get('share-dropdown')) customElements.define('share-dropdown', ShareDropdown);
  if(!customElements.get('share-component')) customElements.define('share-component', class ShareComponent extends ShareDropdown {});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-card"] && !Shopify.designMode) return;
  try {
    class DeferredMedia extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-deferred-media-toggler]');
      this.template = this.querySelector('template');
      const loadMedia = () => {
        if (this.dataset.onHover !== 'true' && typeof window.pauseElementBasedMedia === 'function') {
          window.pauseElementBasedMedia(document.body, this);
        }
        if (this.getAttribute('loaded') === 'true') return;
        this.setAttribute('loaded', 'true');
        if (this.template) {
          const content = this.template.content.cloneNode(true);
          this.appendChild(content);
        }
        const mediaElement = this.querySelector('video, iframe');
        if (mediaElement) {
          if (mediaElement.tagName === 'VIDEO') {
            mediaElement.playsInline = true;
            mediaElement.setAttribute('playsinline', '');
            mediaElement.setAttribute('webkit-playsinline', '');
            if (!mediaElement.getAttribute('src')) {
              const source = mediaElement.querySelector('source');
              if (source && (source.src || source.getAttribute('src'))) {
                mediaElement.src = source.src || source.getAttribute('src');
              }
            }
            mediaElement.load();
            const isAutoplay = window.innerWidth >= 768 && this.closest('[data-video-autoplay="true"]') !== null;
            if (isAutoplay) {
              mediaElement.muted = true;
              mediaElement.setAttribute('muted', '');
            }
            const playPromise = mediaElement.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                mediaElement.muted = true;
                mediaElement.setAttribute('muted', '');
                mediaElement.play().catch(() => {});
              });
            }
          } else if (mediaElement.tagName === 'IFRAME') {
            let src = mediaElement.getAttribute('src');
            if (src && !src.includes('autoplay')) {
              src = src.includes('?') ? `${src}&autoplay=1` : `${src}?autoplay=1`;
            }
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
            if (isIOS && src) {
              if (mediaElement.classList.contains('js-youtube') && !src.includes('mute=1')) {
                src += '&mute=1';
              } else if (mediaElement.classList.contains('js-vimeo') && !src.includes('muted=1')) {
                src += '&muted=1';
              }
            }
            mediaElement.setAttribute('src', src);
            if (mediaElement.classList.contains('js-youtube')) {
              const playYoutube = () => {
                if (mediaElement.contentWindow) {
                  if (isIOS) {
                    mediaElement.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                  }
                  mediaElement.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                }
              };
              mediaElement.addEventListener('load', playYoutube, { once: true });
              playYoutube();
            } else if (mediaElement.classList.contains('js-vimeo')) {
              const playVimeo = () => {
                if (mediaElement.contentWindow) {
                  if (isIOS) {
                    mediaElement.contentWindow.postMessage('{"method":"setVolume","value":0}', '*');
                  }
                  mediaElement.contentWindow.postMessage('{"method":"play"}', '*');
                }
              };
              mediaElement.addEventListener('load', playVimeo, { once: true });
              playVimeo();
            }
          }
        }
      };
      this.loadMediaHandler = loadMedia;
      if (this.button) this.button.addEventListener('click', this.loadMediaHandler);
    }
    disconnectedCallback() {
      const cleanUp = () => {
        if (this.button && this.loadMediaHandler) this.button.removeEventListener('click', this.loadMediaHandler);
      };
      cleanUp();
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);
  } catch(e) { console.error(e); }
})();

})();
